import {
  Direction,
  type EntityRelationsGraphProps,
} from '@backstage/plugin-catalog-graph';
import { C4Node } from '../components/C4Node';
import { C4Label } from '../components/C4Label';

const renderC4Node: EntityRelationsGraphProps['renderNode'] = props => (
  <C4Node {...props} />
);
const renderC4Label: EntityRelationsGraphProps['renderLabel'] = props => (
  <C4Label {...props} />
);

export type C4ViewMode = 'graph' | 'container' | 'component';

export type C4ViewModeKind = 'graph' | 'panel';

export interface C4ViewModeDefinition {
  id: C4ViewMode;
  label: string;
  description: string;
  badge?: 'BETA' | 'ALFA';
  kind: C4ViewModeKind;
  props: Partial<EntityRelationsGraphProps>;
}

const DEPENDENCY_RELATIONS = ['dependsOn', 'dependencyOf'];
const API_RELATIONS = [
  'providesApi',
  'apiProvidedBy',
  'consumesApi',
  'apiConsumedBy',
];

export const C4_VIEW_MODES: Record<C4ViewMode, C4ViewModeDefinition> = {
  graph: {
    id: 'graph',
    label: 'Grafo',
    description: 'Visualização padrão do catálogo, sem customizações C4.',
    kind: 'graph',
    props: {},
  },
  container: {
    id: 'container',
    label: 'C4 — Contêiner (L2)',
    description:
      'Nível 2: contêineres (componentes, recursos e APIs) do sistema e suas dependências.',
    kind: 'graph',
    props: {
      kinds: ['Component', 'Resource', 'API'],
      relations: [...DEPENDENCY_RELATIONS, ...API_RELATIONS],
      maxDepth: 2,
      direction: Direction.TOP_BOTTOM,
      renderNode: renderC4Node,
      renderLabel: renderC4Label,
    },
  },
  component: {
    id: 'component',
    label: 'C4 — Componente (L3)',
    description:
      'Nível 3: componentes internos do contêiner selecionado, declarados na annotation aurum.com.br/c4-components.',
    badge: 'BETA',
    kind: 'panel',
    props: {},
  },
};

export const C4_VIEW_MODE_LIST: C4ViewModeDefinition[] = [
  C4_VIEW_MODES.graph,
  C4_VIEW_MODES.container,
  C4_VIEW_MODES.component,
];

export function isC4ViewMode(value: unknown): value is C4ViewMode {
  return typeof value === 'string' && value in C4_VIEW_MODES;
}
